import { Getters } from '@/models/store/user';

const getters: Getters = {
  storeGet: (state) => state.store,
  tokenParamsGet: (state) => state.tokenParams,
  urlsGet: (state) => state.urls,
};

export default getters;
